import React, { useState } from 'react'
import Nav from '../Navigation/Nav'

const BulkHero = () => {
    const [first, setFirst] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [interest, setInterest] = useState("")
    const [quantity, setQuantity] = useState("")
    const [hosting, setHosting] = useState("")
    return (
        <div className='lg:h-[100vh] flex flex-col lg:px-[8%] px-[4%] relative z-[500] text-white'>
            <Nav />
            <div data-aos="zoom-in" className='w-full flex items-center flex-col gap-5 lg:py-[3%] py-[5%]'>
                <p className='text-4xl font-bold text-blue-400'>Bulk Order</p>
                <div  className='flex flex-col items-center font-bold'>
                    <p>Blockfarms offers special pricing for orders above 20 units.</p>
                    <p className='text-center'>Please fill out the form below and a representative will respond within 24 hours.</p>
                </div>
                <form className='border-2 shadow-blue-500 shadow-md p-5 rounded-xl lg:w-[55%] w-[98%] gap-4 flex flex-col' action="">
                    <div className='grid lg:grid-cols-2 gap-3 grid-cols-1'>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>First Name </p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <input value={first} onChange={(e) => setFirst(e.target.value)} className='w-full rounded-md p-2 text-black outline-none' placeholder='Full Name' type="text" />
                        </span>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>Email address </p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <input value={email} onChange={(e) => setEmail(e.target.value)} className='w-full rounded-md p-2 text-black outline-none' placeholder='Email address' type="email" />
                        </span>
                    </div>
                    <div className='grid lg:grid-cols-2 gap-3 grid-cols-1'>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>Phone Number</p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <input value={phone} onChange={(e) => setPhone(e.target.value)} className='w-full rounded-md p-2 text-black outline-none' placeholder='Number' type="text" />
                        </span>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>Minner of interest</p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <input value={interest} onChange={(e) => setInterest(e.target.value)} className='w-full rounded-md p-2 text-black outline-none' placeholder='Minner of interest' type="email" />
                        </span>
                    </div>
                    <div className='grid lg:grid-cols-2 gap-3 grid-cols-1'>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>Quantity of Miners</p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <input value={quantity} onChange={(e) => setQuantity(e.target.value)} className='w-full  rounded-md text-black p-2 outline-none' placeholder='Minner' type="number" />
                        </span>
                        <span className='flex flex-col gap-2'>
                            <div className='flex items-center gap-2'>
                                <p className='flex items-center font-bold'>Do you require hosting?</p>
                                <span className='text-red-700'>*</span>
                            </div>
                            <select onChange={(e) => setHosting(e.target.value)} className='w-full text-black p-2 outline-none rounded-md' name="" id="">
                                <option value="">Yes</option>
                                <option value="">No</option>
                            </select>
                            {/* <input value={email} onChange={(e)=> setEmail(e.target.value)}  placeholder='Minner of interest' type="email" /> */}
                        </span>
                    </div>
                    <span className='flex flex-col gap-2'>
                        <div className='flex items-center gap-2'>
                            <p className='flex items-center font-bold'>Message (Leave as much detail as possible)</p>
                        </div>
                        <textarea className='rounded-md outline-none p-2 text-black' placeholder='Leave as much detail as possible' name="" rows={4} id=""></textarea>
                    </span>
                    <button className='bg-blue-400 p-3'>Send</button>
                </form>
            </div>
        </div>
    )
}

export default BulkHero